import { State } from "../../../state/store";
import { useSelector } from "react-redux";
import { DiseaseCategoryWithDisease } from "../../../domain/disease_knowledge/DiseaseCategoryWithDisease";
import { DiseaseCategory } from "../../../domain/disease_knowledge/DiseaseCategory";
import { Disease } from "../../../domain/disease_knowledge/Disease";

export const useDiseaseCategories = (): DiseaseCategoryWithDisease[] | null => {
    const responseJsonArray = useSelector((state: State) => state.diseaseKnowledge.diseaseCategories);
    
    return responseJsonArray ? responseJsonArray.diseaseCategories.map(diseaseCategory => 
        DiseaseCategoryWithDisease.from(
            DiseaseCategory.categoryFrom(
                diseaseCategory.id,
                diseaseCategory.name
            ),
            diseaseCategory.diseases.map(disease => (
                new Disease(disease.id, disease.name)
            ))
        )
    ) : null;
};
